
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-series-energy-saving-calculator",
      function () {
        return require("private-next-pages/stream-series-energy-saving-calculator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-series-energy-saving-calculator"])
      });
    }
  